<!-- TOAST -->
<p-toast
  [position]="'top-right'"
  [styleClass]="'right-1 max-w-[100vw]'">
  <ng-template let-message pTemplate="message">
    <ng-container [ngTemplateOutletContext]="{ message: message }" [ngTemplateOutlet]="messageTemplate"></ng-container>
  </ng-template>
</p-toast>

<!-- TEMPLATE -->
<ng-template #messageTemplate let-message="message">
  <div class="flex items-center gap-3 w-full cursor-pointer" (click)="handleNotifTap(message)">
    @switch (message.severity) {
      @case ('info') {
        <i class="text-6 icon-wl-info-circle flex-shrink-0 ml-4"></i>
      }
      @case ('success') {
        <i class="text-6 icon-wl-check-circle flex-shrink-0 ml-4"></i>
      }
      @case ('warn') {
        <i class="text-6 icon-wl-info-circle flex-shrink-0 ml-4"></i>
      }
      @case ('error') {
        <i class="text-6 icon-wl-error-circle flex-shrink-0 ml-4"></i>
      }
      @case ('contrast') {
        <i class="text-6 icon-wl-stars flex-shrink-0 ml-4"></i>
      }
    }
    <div class="toast-content flex-1 min-w-0 pr-3">
      <div class="font-semibold">
        {{ message.summary }}
      </div>
      <div style="word-break: break-word">
        {{ message.detail }}
      </div>
    </div>
  </div>
</ng-template>